import React from 'react';
import Catalog from './containers/Catalog';

function Index(props: any) {
    return (
        <Catalog />
    );
}

export default Index;